import Show from '../show'

function OkgtDashboard() {
  return (
    <Show
      title="OK Grants Dashboard"
      dashboardKey="okgt_dashboards"
    />
  )
}

export default OkgtDashboard
